import request from '@/utils/request'

export function amazonAuth() {
  return request({
    url: '/amazon/auth',
    method: 'get'
  })
}




// WEBPACK FOOTER //
// ./src/api/amazon.js